import { HttpErrorResponse, HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { NavigationExtras, Router } from '@angular/router';
import { catchError, switchMap, throwError } from 'rxjs';
import { SnackbarService } from '../services/snackbar.service';
import { AuthService } from '../services/auth.service';

export const errorInterceptor: HttpInterceptorFn = (req, next) => {
  const router = inject(Router);
  const snackbar = inject(SnackbarService);
  const authService = inject(AuthService);

  return next(req).pipe(
    catchError((err: HttpErrorResponse) => {
      if (err.error?.errors?.length > 0) {
        snackbar.error(err.error.errors[0].message);
      } else if (err.status === 400) {
        if (err.error.errors) {
          const modelStateErrors = [];
          for (const key in err.error.errors) {
            if (err.error.errors[key]) {
              modelStateErrors.push(err.error.errors[key]);
            }
          }
          throw modelStateErrors.flat();
        } else {
          snackbar.error(err.error.title || err.error);
        }
      } else if (err.status === 401) {
        // Пытаемся обновить токен
        return authService.refreshToken().pipe(
          switchMap((newToken) => {
            // Повторяем первоначальный запрос с новым токеном
            const newReq = req.clone({
              setHeaders: {
                Authorization: `Bearer ${newToken.accessToken}`,
              },
            });
            return next(newReq);
          }),
          catchError((refreshError) => {
            // Если обновление токена не удалось, перенаправляем на страницу логина
            router.navigateByUrl('/public/login');
            return throwError(() => refreshError);
          })
        );
      } else if (err.status === 404) {
        // router.navigateByUrl('/not-found');
      } else if (err.status === 500) {
        const navigationExtras: NavigationExtras = {
          state: { error: err.error },
        };
        router.navigateByUrl('/server-error', navigationExtras);
      } else {
        snackbar.error('Произошла неизвестная ошибка');
      }
      return throwError(() => {
        return err;
      });
    })
  );
};
